import type { RescheduleChargeSummary, ScheduleTime } from '@src/core/buyerApiClient';
import type { SchedulingsByDate } from '@src/domains/sale-items/core/reschedule/types';

interface Params {
  schedulingsByDate: SchedulingsByDate;
  date?: string;
  time?: ScheduleTime;
  isWithDateOnly: boolean;
}

export function resolveRescheduleChargeSummary({
  schedulingsByDate,
  date,
  time,
  isWithDateOnly,
}: Params): RescheduleChargeSummary | undefined {
  if (!date) return undefined;

  if (isWithDateOnly) {
    const schedule = schedulingsByDate[date]?.find((scheduling) =>
      scheduling.tariffScheduleUnitPrices.some((tariffScheduleUnitPrice) => tariffScheduleUnitPrice.chargeSummary),
    );

    return schedule?.tariffScheduleUnitPrices.find((tariffScheduleUnitPrice) => tariffScheduleUnitPrice.chargeSummary)
      ?.chargeSummary;
  }

  if (!time) return undefined;

  const schedule = schedulingsByDate[date]?.find((scheduling) =>
    scheduling.availableScheduleTimes?.some((scheduleTime) => scheduleTime.minutes === time.minutes),
  );

  if (!schedule) return undefined;

  return schedule.tariffScheduleUnitPrices.find((tariff) => tariff.time === time.formattedTime)?.chargeSummary;
}
